import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../providers/lang.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'nointernetconnection',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.css']
})

export class NoInternetComponent implements OnInit {
  
  internet_check: String = "";
  public isOnline: boolean = navigator.onLine;
  today: number = Date.now();

  constructor(private langService: LanguageService, ) {
    window.addEventListener('online', () => {
      this.isOnline = true;
    });
    window.addEventListener('offline', () => {
      this.isOnline = false;
    });
  }

  ngOnInit() {
    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });
  }

  setLabels() {
    this.langService.getLangLabelValue("LblInternetConnectivity").then(res => {
      this.internet_check = res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/no-internet/no-internet.component.ts